import * as React from "react";


import Checkbox from "@cayuse/shared-react.components.form.inputs.checkbox";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { Model } from "@flowable/forms";

import styles from "./Checkboxes.css";

const checkDefinition = {
	type: "boolean",
	value: "{{boolVal}}"
};
const textDefinition = {
	type: "text",
	value: "{{textVal}}"
};

class Checkboxes extends Model.FormComponent {
	static $resolve (unresolved, scope, addData, Components) {
		const resolve = Components.panel.$resolve;
		const resolved = resolve(unresolved, scope, addData);
		const disabled = resolved.enabled === false;
		const resolvedCheck = resolve(checkDefinition, resolved.value, addData, disabled);
		const resolvedText = resolve(textDefinition, resolved.value, addData, disabled);

		return { ...resolved, resolvedCheck, resolvedText };
	}

	handleChange = (e, data) => {
		const { onChange, config } = this.props;
		let currentValue = { ...config.value };
		if (config.value === undefined) {
			currentValue = {};
		}
		currentValue[data.label] = data.checked;

		if (!Object.values(currentValue).includes(true)) {
			onChange(false);  // evaluate to false when no checkboxes are checked
		} else {
			onChange(currentValue);
		}
	}

	render () {
		const { config } = this.props;
		const definition = config;
		const hasItems = isNonEmptyArray(config?.extraSettings?.items);
		const disabled = this.props.config.enabled === false;
		if (!definition.resolvedCheck) {
			return null;
		}

		return (
			<div>
				{ /* eslint-disable-next-line camelcase*/ }
				<span className="flw__label"><strong>{config?.i18n?.en_us?.label}</strong></span>
				{config.isRequired && <span className={styles.required}>*</span>}
				{hasItems && config.extraSettings.items.map((item, index) => {
					const value = config.value ? config.value[item.text] : false;

					return (
						// temp fix. is a forced rendering change, after which the focus is lost
						<div key={`${index}-${value}`}>
							<Checkbox
								label={item.text}
								onChange={this.handleChange}
								checked={value}
								disabled={disabled}
								onFocus={this.dispatchFocusEvent}
								onBlur={this.dispatchBlurEvent}
							/>
						</div>
					);
				})}
			</div>
		);
	}
}

export default Checkboxes;
